import { useEffect, useState } from "react";
import Cookies from 'js-cookie'
import {v4 as uuidv4} from 'uuid'

export const useUserAnonId = () => {
  const [userAnonId, setUserAnonId] = useState(null);
  const [typeAccess, setTypeAccess] = useState("return");


  useEffect(() => {
    let storedUserId = Cookies.get('anonInmersialuserId');
    if(!storedUserId) {
      storedUserId = uuidv4();
      setTypeAccess("new");
      Cookies.set('anonInmersialuserId', storedUserId, { expires: 365 });
    }
    setUserAnonId(storedUserId);
  }, [])
  return {
    userAnonId,
    typeAccess    
  };
};
